import ReportsService from '@/services/ReportsService.js'
const namespaced = true
const state = {
    lists: [],
    total_count: '',
    count: 1,
    total_amount: {},
    group_total_amount: [],
    aging_group_total_amount: [],
    export: {},
    list: {},
    warehouse_list: [],
    details: {}


}
const mutations = {
    SET_DATAS(state, lists) {
        state.lists = lists.list
        state.whouse_stock_details = lists.whouse_stock_details,
            state.total_count = lists.total_count
        state.total_amount = lists.total_amount
        state.count = lists.show
        state.group_total_amount = lists.group_total_amount
        state.aging_group_total_amount = lists.aging_group_total_amount
        state.warehouse_list = lists.warehouse_list
    },
    EXPORT_DATAS(state, lists) {
        state.export = lists
    },
    SET_DETAILS(state, data) {
        state.details = data
    }
}

const actions = {
    fetchTaxSummary({
        commit,
        rootState
    }, {

        sort,
        label,
        query
    }) {

        return ReportsService.inventory.getTaxSummary(sort, label, rootState.session.token, query)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('SET_DATAS', response.data.data) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500
                }
            })
    },
    fetchTaxDetails({
        commit,
        rootState
    }, {
        page,
        show,
        sort,
        label,
        query
    }) {

        return ReportsService.inventory.getTaxDetails(page, show, sort, label, rootState.session.token, query)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('SET_DATAS', response.data.data) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500
                }
            })
    },
    fetchTaxDetailExportLists({
        commit,
        rootState
    }, {
        page,
        show,
        sort,
        label,
        query
    }) {

        return ReportsService.inventory.getTaxDetailsExport(page, show, sort, label, rootState.session.token, query)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('EXPORT_DATAS', response.data.list) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    fetchCustomerLists({
        commit,
        rootState
    }, {
        page,
        show,
        sort,
        label,
        query
    }) {

        return ReportsService.app.getSalesByCustomer(page, show, sort, label, rootState.session.token, query)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('SET_DATAS', response.data.data) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    fetchCustomerExportLists({
        commit,
        rootState
    }, {
        page,
        show,
        sort,
        label,
        query
    }) {

        return ReportsService.app.getSalesByCustomerExport(page, show, sort, label, rootState.session.token, query)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('EXPORT_DATAS', response.data.list) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },

    fetchCustomerDetailLists({
        commit,
        rootState
    }, {
        page,
        show,
        sort,
        label,
        query
    }) {

        return ReportsService.app.getSalesByCustomerDetail(page, show, sort, label, rootState.session.token, query)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('SET_DATAS', response.data.data) // getting all the list in the api call
                    return response
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },

    fetchCustomerDetailExportLists({
        commit,
        rootState
    }, {
        page,
        show,
        sort,
        label,
        query
    }) {

        return ReportsService.app.getSalesByCustomerDetailExport(page, show, sort, label, rootState.session.token, query)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('EXPORT_DATAS', response.data.list) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    fetchSoByCusLists({
        commit,
        rootState
    }, {
        page,
        show,
        sort,
        label,
        query
    }) {

        return ReportsService.app.getSoByCus(page, show, sort, label, rootState.session.token, query)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('SET_DATAS', response.data.data) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    fetchSoByCusExportLists({
        commit,
        rootState
    }, {
        page,
        show,
        sort,
        label,
        query
    }) {

        return ReportsService.app.getSoByCusExport(page, show, sort, label, rootState.session.token, query)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('EXPORT_DATAS', response.data.list) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },

    fetchSoByCusDetailLists({
        commit,
        rootState
    }, {
        page,
        show,
        sort,
        label,
        query
    }) {

        return ReportsService.app.getSoByCusDetail(page, show, sort, label, rootState.session.token, query)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('SET_DATAS', response.data.data) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },

    fetchSoByCusDetailExportLists({
        commit,
        rootState
    }, {
        page,
        show,
        sort,
        label,
        query
    }) {

        return ReportsService.app.getSoByCusDetailExport(page, show, sort, label, rootState.session.token, query)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('EXPORT_DATAS', response.data.list) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    fetchProductLists({
        commit,
        rootState
    }, {
        page,
        show,
        sort,
        label,
        query
    }) {

        return ReportsService.app.getSalesByProduct(page, show, sort, label, rootState.session.token, query)
            .then(response => {

                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('SET_DATAS', response.data.data) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500
                }
            })
    },
    fetchProductExportLists({
        commit,
        rootState
    }, {
        page,
        show,
        sort,
        label,
        query
    }) {

        return ReportsService.app.getSalesByProductExport(page, show, sort, label, rootState.session.token, query)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('EXPORT_DATAS', response.data.list) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500
                }
            })
    },
    fetchProductDetailLists({
        commit,
        rootState
    }, {
        page,
        show,
        sort,
        label,
        query
    }) {

        return ReportsService.app.getSalesByProductDetail(page, show, sort, label, rootState.session.token, query)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('SET_DATAS', response.data.data) // getting all the list in the api call
                    return response
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500
                }
            })
    },
    fetchProductDetailExportLists({
        commit,
        rootState
    }, {
        page,
        show,
        sort,
        label,
        query
    }) {

        return ReportsService.app.getSalesByProductDetailExport(page, show, sort, label, rootState.session.token, query)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('EXPORT_DATAS', response.data.list) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500
                }
            })
    },
    fetchSalesPersonLists({
        commit,
        rootState
    }, {
        page,
        show,
        sort,
        label,
        query
    }) {

        return ReportsService.app.getSalesBySalesPerson(page, show, sort, label, rootState.session.token, query)
            .then(response => {

                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('SET_DATAS', response.data.data) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500
                }
            })
    },
    fetchSalesPersonExportLists({
        commit,
        rootState
    }, {
        page,
        show,
        sort,
        label,
        query
    }) {

        return ReportsService.app.getSalesBySalesPersonExport(page, show, sort, label, rootState.session.token, query)
            .then(response => {

                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('EXPORT_DATAS', response.data.list) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500
                }
            })
    },
    fetchSalesPersonDetailLists({
        commit,
        rootState
    }, {
        page,
        show,
        sort,
        label,
        query
    }) {

        return ReportsService.app.getSalesBySalesPersonDetail(page, show, sort, label, rootState.session.token, query)
            .then(response => {

                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('SET_DATAS', response.data.data) // getting all the list in the api call
                    return response
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500
                }
            })
    },
    fetchSalesPersonDetailExportLists({
        commit,
        rootState
    }, {
        page,
        show,
        sort,
        label,
        query
    }) {

        return ReportsService.app.getSalesBySalesPersonDetailExport(page, show, sort, label, rootState.session.token, query)
            .then(response => {

                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('EXPORT_DATAS', response.data.list) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500
                }
            })
    },
    fetchInvoiceLists({
        commit,
        rootState
    }, {
        page,
        show,
        sort,
        label,
        query
    }) {

        return ReportsService.app.getSalesByInvoice(page, show, sort, label, rootState.session.token, query)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('SET_DATAS', response.data.data) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500
                }
            })
    },
    fetchinvoiceexportLists({
        commit,
        rootState
    }, {
        page,
        show,
        sort,
        label,
        query
    }) {

        return ReportsService.app.getSalesByInvoiceExport(page, show, sort, label, rootState.session.token, query)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('EXPORT_DATAS', response.data.list) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500
                }
            })
    },
    fetchEstimateLists({
        commit,
        rootState
    }, {
        page,
        show,
        sort,
        label,
        query
    }) {

        return ReportsService.app.getSalesByEstimate(page, show, sort, label, rootState.session.token, query)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('SET_DATAS', response.data.data) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500
                }
            })
    },
    fetchEstimateexportLists({
        commit,
        rootState
    }, {
        page,
        show,
        sort,
        label,
        query
    }) {

        return ReportsService.app.getSalesByEstimateExport(page, show, sort, label, rootState.session.token, query)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('EXPORT_DATAS', response.data.list) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500
                }
            })
    },
    fetchPaymentLists({
        commit,
        rootState
    }, {
        page,
        show,
        sort,
        label,
        query
    }) {

        return ReportsService.app.getSalesByPayment(page, show, sort, label, rootState.session.token, query)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('SET_DATAS', response.data.data) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500
                }
            })
    },
    fetchpaymentexportLists({
        commit,
        rootState
    }, {
        page,
        show,
        sort,
        label,
        query
    }) {

        return ReportsService.app.getSalesByPaymentExport(page, show, sort, label, rootState.session.token, query)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('EXPORT_DATAS', response.data.list) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500
                }
            })
    },


    fetchAgingDetialLists({
        commit,
        rootState
    }, {
        page,
        show,
        sort,
        label,
        query
    }) {

        return ReportsService.app.getAgingDetails(page, show, sort, label, rootState.session.token, query)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('SET_DATAS', response.data.data) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500
                }
            })
    },
    fetchAmcContractLists({
        commit,
        rootState
    }, {
        page,
        show,
        sort,
        label,
        query
    }) {

        return ReportsService.app.getAmcContract(page, show, sort, label, rootState.session.token, query)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('SET_DATAS', response.data.data) // getting all the list in the api call

                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500
                }
            })
    },
    fetchAgingDetialExportLists({
        commit,
        rootState
    }, {
        page,
        show,
        sort,
        label,
        query
    }) {

        return ReportsService.app.getAgingDetailsExport(page, show, sort, label, rootState.session.token, query)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('EXPORT_DATAS', response.data.list) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500
                }
            })
    },
    fetchCreditLists({
        commit,
        rootState
    }, {
        page,
        show,
        sort,
        label,
        query
    }) {

        return ReportsService.app.getSalesByCredit(page, show, sort, label, rootState.session.token, query)
            .then(response => {
                // return
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('SET_DATAS', response.data.data) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500
                }
            })
    },
    fetchcreditexportLists({
        commit,
        rootState
    }, {
        page,
        show,
        sort,
        label,
        query
    }) {

        return ReportsService.app.getSalesByCreditExport(page, show, sort, label, rootState.session.token, query)
            .then(response => {
                // return
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('EXPORT_DATAS', response.data.list) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500
                }
            })
    },
    fetchRetainerLists({
        commit,
        rootState
    }, {
        page,
        show,
        sort,
        label,
        query
    }) {

        return ReportsService.app.getSalesByRetainer(page, show, sort, label, rootState.session.token, query)
            .then(response => {
                // return
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('SET_DATAS', response.data.data) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500
                }
            })
    },
    fetchretainerexportLists({
        commit,
        rootState
    }, {
        page,
        show,
        sort,
        label,
        query
    }) {

        return ReportsService.app.getSalesByRetainerExport(page, show, sort, label, rootState.session.token, query)
            .then(response => {
                // return
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('EXPORT_DATAS', response.data.list) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500
                }
            })
    },
    fetchCustomerBalancesLists({
        commit,
        rootState
    }, {
        page,
        show,
        sort,
        label,
        query
    }) {

        return ReportsService.app.getCustomerBalances(page, show, sort, label, rootState.session.token, query)
            .then(response => {
                // return
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('SET_DATAS', response.data.data) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500
                }
            })
    },
    fetchCustomerBalancesExportLists({
        commit,
        rootState
    }, {
        page,
        show,
        sort,
        label,
        query
    }) {

        return ReportsService.app.getCustomerBalancesExport(page, show, sort, label, rootState.session.token, query)
            .then(response => {
                // return
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('EXPORT_DATAS', response.data.list) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500
                }
            })
    },
    fetchCustomerBalanceFilterDetailLists({
        commit,
        rootState
    }, {
        page,
        show,
        sort,
        label,
        query
    }) {

        return ReportsService.app.getCustomerBalanceFilterDetail(page, show, sort, label, rootState.session.token, query)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('SET_DATAS', response.data.data) // getting all the list in the api call
                    return response
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500
                }
            })
    },
    fetchCustomerBalanceFilterDetailExportLists({
        commit,
        rootState
    }, {
        page,
        show,
        sort,
        label,
        query
    }) {

        return ReportsService.app.getCustomerBalanceFilterDetailExport(page, show, sort, label, rootState.session.token, query)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('EXPORT_DATAS', response.data.list) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500
                }
            })
    },
    fetchPaymentsReceivedLists({
        commit,
        rootState
    }, {
        page,
        show,
        sort,
        label,
        query
    }) {

        return ReportsService.app.getPaymentsReceived(page, show, sort, label, rootState.session.token, query)
            .then(response => {
                // return
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('SET_DATAS', response.data.data) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500
                }
            })
    },
    fetchPaymentsReceivedExportLists({
        commit,
        rootState
    }, {
        page,
        show,
        sort,
        label,
        query
    }) {

        return ReportsService.app.getPaymentsReceivedExport(page, show, sort, label, rootState.session.token, query)
            .then(response => {
                // return
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('EXPORT_DATAS', response.data.list) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500
                }
            })
    },
    fetchRefundHistoryLists({
        commit,
        rootState
    }, {
        page,
        show,
        sort,
        label,
        query
    }) {

        return ReportsService.app.getRefundHistory(page, show, sort, label, rootState.session.token, query)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('SET_DATAS', response.data.data) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500
                }
            })
    },
    fetchRefundHistoryExportLists({
        commit,
        rootState
    }, {
        page,
        show,
        sort,
        label,
        query
    }) {

        return ReportsService.app.getRefundHistoryExport(page, show, sort, label, rootState.session.token, query)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('EXPORT_DATAS', response.data.list) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500
                }
            })
    },
    fetchRecurringInvoiceLists({
        commit,
        rootState
    }, {
        page,
        show,
        sort,
        label,
        query
    }) {

        return ReportsService.app.getRecurringInvoiceReport(page, show, sort, label, rootState.session.token, query)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('SET_DATAS', response.data.data) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500
                }
            })
    },
    fetchRecurringInvoiceExportLists({
        commit,
        rootState
    }, {
        page,
        show,
        sort,
        label,
        query
    }) {

        return ReportsService.app.getRecurringInvoiceReportExport(page, show, sort, label, rootState.session.token, query)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('EXPORT_DATAS', response.data.list) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500
                }
            })
    },
    fetchTDSDetailsLists({
        commit,
        rootState
    }, {
        page,
        show,
        sort,
        label,
        query
    }) {

        return ReportsService.app.getTDSDetails(page, show, sort, label, rootState.session.token, query)
            .then(response => {
                // return
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('SET_DATAS', response.data.data) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500
                }
            })
    },
    fetchTdsDetailsExportLists({
        commit,
        rootState
    }, {
        page,
        show,
        sort,
        label,
        query
    }) {

        return ReportsService.app.getTdsDetailsExport(page, show, sort, label, rootState.session.token, query)
            .then(response => {

                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('EXPORT_DATAS', response.data.list) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500
                }
            })
    },
    fetchTdsDetailfilterLists({
        commit,
        rootState
    }, {
        page,
        show,
        sort,
        label,
        query
    }) {

        return ReportsService.app.getTdsDetailfilterLists(page, show, sort, label, rootState.session.token, query)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('SET_DATAS', response.data.data) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500
                }
            })
    },
    fetchTdsDetailfilterExportLists({
        commit,
        rootState
    }, {
        page,
        show,
        sort,
        label,
        query
    }) {

        return ReportsService.app.getTdsDetailfilterListsExport(page, show, sort, label, rootState.session.token, query)
            .then(response => {

                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('EXPORT_DATAS', response.data.list) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500
                }
            })
    },
    fetchBankChargesLists({
        commit,
        rootState
    }, {
        page,
        show,
        sort,
        label,
        query
    }) {

        return ReportsService.app.getBankCharges(page, show, sort, label, rootState.session.token, query)
            .then(response => {
                // return
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('SET_DATAS', response.data.data) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500
                }
            })
    },
    fetchBankChargesExportLists({
        commit,
        rootState
    }, {
        page,
        show,
        sort,
        label,
        query
    }) {

        return ReportsService.app.getBankChargesExport(page, show, sort, label, rootState.session.token, query)
            .then(response => {

                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('EXPORT_DATAS', response.data.list) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500
                }
            })
    },
    fetchBankChargesfilterLists({
        commit,
        rootState
    }, {
        page,
        show,
        sort,
        label,
        query
    }) {

        return ReportsService.app.getBankChargesfilterLists(page, show, sort, label, rootState.session.token, query)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('SET_DATAS', response.data.data) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500
                }
            })
    },
    fetchBankChargesfilterExportLists({
        commit,
        rootState
    }, {
        page,
        show,
        sort,
        label,
        query
    }) {

        return ReportsService.app.getBankChargesfilterListsExport(page, show, sort, label, rootState.session.token, query)
            .then(response => {

                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('EXPORT_DATAS', response.data.list) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500
                }
            })
    },
    fetchPackageLists({
        commit,
        rootState
    }, {
        page,
        show,
        sort,
        label,
        query
    }) {

        return ReportsService.app.getPackages(page, show, sort, label, rootState.session.token, query)
            .then(response => {
                // return
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('SET_DATAS', response.data.data) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500
                }
            })
    },
    fetchPackagesExportLists({
        commit,
        rootState
    }, {
        page,
        show,
        sort,
        label,
        query
    }) {

        return ReportsService.app.getPackagesExport(page, show, sort, label, rootState.session.token, query)
            .then(response => {
                // return
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('EXPORT_DATAS', response.data.list) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500
                }
            })
    },
    fetchStockSummaryLists({
        commit,
        rootState
    }, {
        page,
        show,
        sort,
        label,
        query
    }) {

        return ReportsService.app.getStockSummary(page, show, sort, label, rootState.session.token, query)
            .then(response => {
                // return
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('SET_DATAS', response.data.data) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500
                }
            })
    },
    fetchInventoryLists({
        commit,
        rootState
    }, {
        page,
        show,
        sort,
        label,
        query
    }) {

        return ReportsService.app.getInventory(page, show, sort, label, rootState.session.token, query)
            .then(response => {
                // return
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('SET_DATAS', response.data.data) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500
                }
            })
    },
    fetchInventorySummaryExport({
        commit,
        rootState
    }, {
        page,
        show,
        sort,
        label,
        query
    }) {

        return ReportsService.app.getInventoryExport(page, show, sort, label, rootState.session.token, query)
            .then(response => {
                // return
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('EXPORT_DATAS', response.data.list) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500
                }
            })
    },
    fetchSalesOrderLists({
        commit,
        rootState
    }, {
        page,
        show,
        sort,
        label,
        query
    }) {

        return ReportsService.app.getSalesOrder(page, show, sort, label, rootState.session.token, query)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('SET_DATAS', response.data.data) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    fetchSalesOrderExportLists({
        commit,
        rootState
    }, {
        page,
        show,
        sort,
        label,
        query
    }) {

        return ReportsService.app.getSalesOrderExport(page, show, sort, label, rootState.session.token, query)
            .then(response => {

                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('EXPORT_DATAS', response.data.list) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    fetchReceiveLists({
        commit,
        rootState
    }, {
        page,
        show,
        sort,
        label,
        query
    }) {

        return ReportsService.app.getReceive(page, show, sort, label, rootState.session.token, query)
            .then(response => {
                // return
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('SET_DATAS', response.data.data) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500
                }
            })
    },
    fetchReceiveExportLists({
        commit,
        rootState
    }, {
        page,
        show,
        sort,
        label,
        query
    }) {

        return ReportsService.app.getReceiveExport(page, show, sort, label, rootState.session.token, query)
            .then(response => {
                // return
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('EXPORT_DATAS', response.data.list) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500
                }
            })
    },
    fetchReturnLists({
        commit,
        rootState
    }, {
        page,
        show,
        sort,
        label,
        query
    }) {

        return ReportsService.app.getReturn(page, show, sort, label, rootState.session.token, query)
            .then(response => {
                // return
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('SET_DATAS', response.data.data) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500
                }
            })
    },
    fetchFulfilmentLists({
        commit,
        rootState
    }, {
        page,
        show,
        sort,
        label,
        query
    }) {

        return ReportsService.app.getFulfillment(page, show, sort, label, rootState.session.token, query)
            .then(response => {
                // return
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('SET_DATAS', response.data.data) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500
                }
            })
    },
    fetchFulfilmentExportLists({
        commit,
        rootState
    }, {
        page,
        show,
        sort,
        label,
        query
    }) {

        return ReportsService.app.getFulfillmentExport(page, show, sort, label, rootState.session.token, query)
            .then(response => {
                // return
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('EXPORT_DATAS', response.data.list) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500
                }
            })
    },
    fetchwarehouseDetails({
        commit,
        rootState
    }) {

        return ReportsService.app.getwarehouseDetails(rootState.session.token)
            .then(response => {
                // return
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('SET_DETAILS', response.data) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500
                }
            })
    },
    fetchwarehouseLists({
        commit,
        rootState
    }, {
        page,
        show,
        sort,
        label,
        query
    }) {

        return ReportsService.app.getwarehouse(page, show, sort, label, rootState.session.token, query)
            .then(response => {
                // return
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('SET_DATAS', response.data.data) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500
                }
            })
    },
    fetchWarehouseExportLists({
        commit,
        rootState
    }, {
        page,
        show,
        sort,
        label,
        query
    }) {

        return ReportsService.app.getwarehouseExport(page, show, sort, label, rootState.session.token, query)
            .then(response => {
                // return
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('EXPORT_DATAS', response.data.list) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500
                }
            })
    },
    fetchWarehouseDetails({
        commit,
        rootState
    }) {
        return ReportsService.app.getWarehouseDetails(rootState.session.token)
            .then(response => {
                commit('DETAILS', response.data) // getting all the list in the api call
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    fetchStocksummaryExport({
        commit,
        rootState
    }, {
        page,
        show,
        sort,
        label,
        query
    }) {

        return ReportsService.app.getstocksummaryExport(page, show, sort, label, rootState.session.token, query)
            .then(response => {
                // return
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('EXPORT_DATAS', response.data.list) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500
                }
            })
    },
    fetchSalesgstExportLists({
        commit,
        rootState
    }, {
        page,
        show,
        query
    }) {

        return ReportsService.app.getSalesgstExport(page, show, query, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('EXPORT_DATAS', response.data.list) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500
                }
            })
    },
    fetchPurchasegstExportLists({
        commit,
        rootState
    }, {
        page,
        show
    }) {

        return ReportsService.inventory.getPurchasegstExport(page, show, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('EXPORT_DATAS', response.data.list) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500
                }
            })
    },
    fetchGSTLists({
        commit,
        rootState
    }, {
        page,
        show,
        sort,
        label,
        query
    }) {

        return ReportsService.app.getGstLists(page, show, sort, label, rootState.session.token, query)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('SET_DATAS', response.data.data) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
}
export default {
    namespaced,
    state,
    mutations,
    actions
}